<template>
  <v-card class="wrapper table-wrapper d-flex flex-column pa-4 ma-0 gap-1">
    <AppBar
      :secondary="secondary"
      :third="third"
      :id="itemID"
      :edit="isEditMode"
      :loader="isLoading"
      @get-items="handleGetItems"
      @open-filters="handleFilters"
      :salary-factor-items="items"
      :isDisabled="isDisabled"
    />
    <div
      v-if="initialLoading"
      class="mt-4"
      style="height: calc(100vh - 158px); overflow: hidden"
    ></div>
    <TableList
      v-show="!initialLoading"
      @call-refresh="handleChange"
      @initial-Loading-is="handleLoading"
      :call-refresh="refresh"
      @salary-factor-items="handleItems"
      @back-to-pending="handleBackToPending"
      :call-function="callFunction"
      :row="rowData"
      class=""
    />
    <PermissionDialog
      :askPerm="askPerm"
      :txtPerm="$t('Are you sure about correcting these rights?')"
      :detailPerm="detailPerm"
      @accept="handleAccept"
      :permType="true"
      :dialogWidth="320"
      @deny="askPerm = false"
    />
    <!-- Refresh overlay -->
    <v-overlay absolute :value="refresh" opacity="0.1">
      <v-progress-circular indeterminate size="26" width="3" color="primary" />
    </v-overlay>
  </v-card>
</template>

<script>
import AppBar from "@/views/dashboard/pages/payroll/saleryOperations/partial/AppBar.vue";
import TableList from "@/views/dashboard/pages/payroll/saleryOperations/partial/TableList.vue";
import TablePersonnelList from "@/views/dashboard/pages/payroll/saleryOperations/partial/TablePersonnelList.vue";
import PermissionDialog from "@/views/dashboard/pages/invoice/CashRegister/partial/PermissionDialog.vue";

export default {
  name: "salaryOperation",
  components: {
    AppBar,
    TableList,
    TablePersonnelList,
    PermissionDialog,
  },
  data: () => ({
    refresh: false,
    openNavigationDrawer: false,
    initialLoading: true,
    secondary: false,
    third: false,
    isLoading: false,
    isEditMode: false,
    items: null,
    itemID: null,
    List: true,
    isDisabled: false,
    askPerm: false,
    clearForm: false,
    callFunction: false,
    detailPerm: "",
    rowData: null,
  }),
  created() {
    this.secondary = true;
    this.third = false;
  },
  methods: {
    handleItems(val) {
      this.items = val;
    },
    handleAccept() {
      this.callFunction = true;
    },
    handleBackToPending(val) {
      this.rowData = val;
      this.askPerm = true;
    },
    handleGetItems() {
      this.refresh = true;
      this.initialLoading = false;
    },
    handleChange() {
      this.refresh = false;
    },
    handleFilters() {
      this.openNavigationDrawer = true;
    },
    handleCloseFilter() {
      this.openNavigationDrawer = false;
    },
    handleLoading(val) {
      this.initialLoading = val;
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: calc(100vh - 100px);
  width: 100%;
}
.table-wrapper {
  position: relative;
  min-height: 300px;
}
</style>
